jQuery.noConflict();
jQuery(document).ready(function($) {
  $('.upcoming_auction_read_more').click(function(event){
    event.preventDefault();
    $(this).toggleClass('open');
    if($(this).hasClass('open')){
      $(this).html($(this).data('translation-hide'));
      $(this).closest('.upcoming_auction_description_container').find('.upcoming_auction_description_full').show();
      $(this).closest('.upcoming_auction_description_container').find('.upcoming_auction_description').hide();
    }
    else{
      $(this).html($(this).data('translation-readmore'));
      $(this).closest('.upcoming_auction_description_container').find('.upcoming_auction_description_full').hide();
      $(this).closest('.upcoming_auction_description_container').find('.upcoming_auction_description').show();
    }

  });
});
